// ── Feature 004: super-admin da plataforma ──
// Diferente de `isOwner` (dono de UMA clínica — todo assinante é owner da sua),
// o platformAdmin opera o SaaS inteiro: define provedores/modelos de IA e a
// política de roteamento. É uma decisão de plataforma, não de clínica, então
// NÃO pode ser protegida por `isOwner`. Identificado por e-mail numa allowlist
// explícita.
//
// Edite esta lista para conceder acesso ao Laboratório de IA (/admin/ia).
export const PLATFORM_ADMIN_EMAILS: readonly string[] = [
  'leopinheiro2005@gmail.com',
];

/** True quando o e-mail pertence à allowlist de super-admin da plataforma. */
export function isPlatformAdminEmail(email?: string | null): boolean {
  if (!email) return false;
  return PLATFORM_ADMIN_EMAILS.includes(email.trim().toLowerCase());
}
